import {NgModule} from '@angular/core';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import {PanelModule} from 'primeng/panel';
import {ButtonModule} from 'primeng/button';
import {InputTextModule} from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { InputSwitchModule } from 'primeng/inputswitch';
import {MessagesModule} from 'primeng/messages';
import {MessageModule} from 'primeng/message';
import {ToolbarModule} from 'primeng/toolbar';
import {MenubarModule} from 'primeng/menubar';
import {MenuModule} from 'primeng/menu';
import {SlideMenuModule} from 'primeng/slidemenu';
import {DropdownModule} from 'primeng/dropdown';
import {CalendarModule} from 'primeng/calendar';
import {TableModule} from 'primeng/table';
import {DialogModule} from 'primeng/dialog';
import {SplitButtonModule} from 'primeng/splitbutton';
import {CheckboxModule} from 'primeng/checkbox';
import {CardModule} from 'primeng/card';
import {ProgressBarModule} from 'primeng/progressbar';
import {MultiSelectModule} from 'primeng/multiselect';
import {KeyFilterModule} from 'primeng/keyfilter';
import {ProgressSpinnerModule} from 'primeng/progressspinner';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {TabMenuModule} from 'primeng/tabmenu';
import {TabViewModule} from 'primeng/tabview';
import {PasswordModule} from 'primeng/password';
import {FieldsetModule} from 'primeng/fieldset';
import {AccordionModule} from 'primeng/accordion';
import {ToastModule} from 'primeng/toast';
import {PanelMenuModule} from 'primeng/panelmenu';
import {TieredMenuModule} from 'primeng/tieredmenu';
import {TooltipModule} from 'primeng/tooltip';
import {InputGroupModule} from 'primeng/inputgroup';
import {InputGroupAddonModule} from 'primeng/inputgroupaddon';
import {PaginatorModule} from 'primeng/paginator';
import { TimelineModule } from 'primeng/timeline';
import { RouterModule } from '@angular/router';
import {CarouselModule} from 'primeng/carousel';
import { SplitterModule } from 'primeng/splitter';
import { ChartModule } from 'primeng/chart';
import { InputNumberModule } from 'primeng/inputnumber';
import { FormsModule } from '@angular/forms';
import {RippleModule} from 'primeng/ripple';
import { DockModule } from 'primeng/dock';
import { RadioButtonModule } from 'primeng/radiobutton';
import { TagModule } from 'primeng/tag';
import { ChipModule } from 'primeng/chip';
import { AvatarModule } from 'primeng/avatar';
import { AvatarGroupModule } from 'primeng/avatargroup';
import { FileUploadModule } from 'primeng/fileupload';
import { FloatLabelModule } from 'primeng/floatlabel';
import { BadgeModule } from 'primeng/badge';
import { StepsModule } from 'primeng/steps';
import { SidebarModule } from 'primeng/sidebar';
import { AutoCompleteModule } from 'primeng/autocomplete';
const MODULES = [
  TagModule,
  ChipModule,
  AvatarModule,
  AvatarGroupModule,
  DockModule,
  FormsModule,
  InputNumberModule,
  RadioButtonModule,
  ChartModule,
  PanelModule,
  ButtonModule,
  InputTextModule,
  MessagesModule,
  MessageModule,
  ToolbarModule,
  MenubarModule,
  InputTextareaModule,
  SlideMenuModule,
  MenuModule,
  DropdownModule,
  CalendarModule,
  TableModule,
  DialogModule,
  SplitButtonModule,
  CheckboxModule,
  CardModule,
  ProgressBarModule,
  MultiSelectModule,
  PaginatorModule,
  KeyFilterModule,
  ProgressSpinnerModule,
  InputSwitchModule,
  ConfirmDialogModule,
  TabMenuModule,
  TabViewModule,
  PasswordModule,
  FieldsetModule,
  AccordionModule,
  ToastModule,
  PanelMenuModule,
  TieredMenuModule,
  TooltipModule,
  InputGroupModule,
  InputGroupAddonModule,
  TimelineModule,
  CarouselModule,
  SplitterModule,
  RippleModule,
  FileUploadModule,
  FloatLabelModule,
  BadgeModule,
  StepsModule,
  AutoCompleteModule,
  SidebarModule
];

@NgModule({
  imports: [...MODULES],
  exports: [...MODULES]
})
export class PrimeNgModule { }